/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { Redirect } from "react-router";
import { useLocation } from "react-router-dom";
import { STATES } from "../../model/rematch";
import createRedisRematch, { setRedisRematch } from "../../utils/redisRematch";
import { useRematch } from "../../viewmodel/hooks/getRematch";
import { UserContext } from "../../viewmodel/providers/user-context";
import "../css/MenuStart.css";
import ReplayLoading from "./WaitingLoading";

import routes from "../../utils/routes.json";
import { useProfile } from "../../viewmodel/hooks/getProfile";
import { getUserInfo } from "../../viewmodel/providers/userInfo";

type locationState = {
    oponnentId: string,
    confirm: boolean,
    categoryIds: string[],
}

export default function Rematch(): JSX.Element {
    console.log("a");
    const [state, setRematchState, setOpponent, setChannelId] = useRematch();
    const userId: string = React.useContext(UserContext).userId;

    const location: locationState = useLocation<locationState>().state;

    setRedisRematch(state);

    useEffect(() => {
        const redisRematch =
            createRedisRematch(location.oponnentId, state, setRematchState, setOpponent, setChannelId, userId, location.categoryIds);
        redisRematch.sendAcceptGame();
        return () => {
            redisRematch.close();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [opponent, setProfileOpponent] = useProfile();
    useEffect(() => {
        if (location)
            getUserInfo(location.oponnentId, setProfileOpponent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.oponnentId]);

    if (!location)
        return <Redirect to={routes.menu} />;

    let component = <ReplayLoading user={opponent.user} />;
    if (state.state === STATES.START_GAME)
        component =
            <Redirect
                to={{
                    pathname: routes.game,
                    state: {
                        channelId: state.channelId,
                        opponentId: state.opponentId,
                        userId: userId,
                        categoryIds: location.categoryIds,
                    },
                }}
            />;

    return (
        component
    );
}
